import { firebaseDatabase } from "../config/firebase.config";
import { MESSAGE_TYPES as msg } from "../utils/js/constants";

const manufacturerDatabaseRef = firebaseDatabase.ref("/fabricante");

/*const deleteCurrentManufacturer = () => {
    manufacturerDatabaseRef.remove();
}*/

const createCurrentManufacturer = (manufacturer, callback = () => { }) => {
    let data = {};

    manufacturerDatabaseRef.push(manufacturer)
        .then(() => {
            data = { message: msg.MANUFACTURER_CREATE, result: null, error: null}
        })
        .catch((error) => {
            data = { message: msg.MANUFACTURER_CREATE_ERROR, result: null, error: error}
        }).finally(() => callback(data));
}

const updateCurrentManufacturer = (key, manufacturer, callback = () => { }) => {
    manufacturerDatabaseRef.child(key).update(manufacturer)
        .then(() => ({ message: msg.MANUFACTURER_UPDATE, result: manufacturer, error: null }))
        .catch((error) => ({
            message: msg.MANUFACTURER_UPDATE_ERROR, result: null, error: error 
        }));
}

const getCurrentManufacturer = (callback = () => { }) => {

    manufacturerDatabaseRef.on('value', (snapshot) => {
        let fabricanteReturned = {};

        snapshot.forEach((childSnapshot) => {
            let childKey = childSnapshot.key;
            let childData = childSnapshot.val();
            childData.Id = childKey;
            fabricanteReturned = childData;
        });

        callback(fabricanteReturned)
    });

}

export { createCurrentManufacturer, updateCurrentManufacturer, getCurrentManufacturer };

